import { DrawerComponentsEnum } from "./DrawerComponentsEnum";

export class DrawerState {
    showRightDrawer: boolean = false;
    rightDrawerComponent: number = DrawerComponentsEnum.NOTIFICATIONS;
}